(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mobile = window.matchMedia('(max-width: 749px)').matches;
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

  document.documentElement.classList.add('av-motion-ready');

  const tag = (els, attr, value = '') => els.forEach(el => {
    if (!el.hasAttribute(attr)) el.setAttribute(attr, value);
  });

  const prepare = () => {
    const hero = document.querySelector('.av-hero');
    if (hero) requestAnimationFrame(() => hero.classList.add('is-entered'));

    tag(qsa('.av-product__info > *, .av-benefits > div, .av-pdp-utility article, .av-pdp-editorial > *, .av-catalog-card, .av-contact__detail-block, .av-contact__form-shell, .av-contact__utility-card, .av-trust-logo, .av-footer-brand'), 'data-av-reveal');
    tag(qsa('.av-product__gallery, .av-story__sticky, .av-pdp-story__visual'), 'data-av-reveal', 'left');
    tag(qsa('.av-story__step, .av-pdp-story__copy'), 'data-av-reveal', 'right');
    tag(qsa('.av-catalog__hero h1, .av-contact__hero h1, .av-pdp-finalcta h2, .av-final h2, .av-product__info h2, #MainContent[data-template^="product"] .product-details h1'), 'data-av-type');
    tag(qsa('.av-specs, .av-catalog-card__meta, .av-contact__detail-block, .av-pdp-details'), 'data-av-line');

    qsa('.av-hero__frame img, .av-story__sticky img, .av-pdp-story__visual img, .av-final>img, .av-pdp-editorial__wide img').forEach((el, i) => {
      el.setAttribute('data-av-parallax', i % 2 ? '0.65' : '0.45');
    });

    qsa('[data-av-reveal], [data-av-type], [data-av-line]').forEach((el, i) => {
      if (!el.style.getPropertyValue('--av-delay')) el.style.setProperty('--av-delay', `${Math.min((i % 5) * 55, 220)}ms`);
    });
  };

  const observeReveals = () => {
    if (reduced || !('IntersectionObserver' in window)) {
      qsa('[data-av-reveal], [data-av-type], [data-av-line]').forEach(el => el.classList.add('is-inview'));
      return;
    }
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: mobile ? 0.08 : 0.16, rootMargin: '0px 0px -5% 0px' });
    qsa('[data-av-reveal], [data-av-type], [data-av-line]').forEach(el => io.observe(el));
  };

  const parallax = () => {
    if (reduced) return;
    const els = qsa('[data-av-parallax]');
    if (!els.length) return;
    let ticking = false;
    const update = () => {
      const vh = window.innerHeight || 1;
      els.forEach(el => {
        const r = el.getBoundingClientRect();
        if (r.bottom < -120 || r.top > vh + 120) return;
        const progress = (r.top + r.height / 2 - vh / 2) / vh;
        const strength = Number(el.dataset.avParallax || .45);
        const max = mobile ? 13 : 28;
        const y = Math.max(-max, Math.min(max, -progress * max * strength));
        el.style.setProperty('--av-y', `${y.toFixed(2)}px`);
      });
      ticking = false;
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    update();
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
  };

  const storyProgress = () => {
    if (reduced) return;
    const story = document.querySelector('.av-story--motion');
    const meter = story?.querySelector('.av-story__meter');
    if (!story || !meter) return;
    const current = meter.querySelector('[data-av-story-current]');
    const steps = qsa('.av-story__step', story);
    let ticking = false;
    const update = () => {
      const r = story.getBoundingClientRect();
      const travel = Math.max(1, r.height - window.innerHeight);
      const progress = Math.max(0, Math.min(1, -r.top / travel));
      meter.style.setProperty('--av-story-progress', progress.toFixed(3));
      let index = 0;
      const targetY = window.innerHeight * .48;
      steps.forEach((step, i) => { if (step.getBoundingClientRect().top <= targetY) index = i; });
      if (current) current.textContent = String(Math.min(steps.length, index + 1)).padStart(2, '0');
      ticking = false;
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    update();
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
  };

  const marquee = () => {
    const el = document.querySelector('.av-marquee');
    if (!el) return;
    el.style.setProperty('--av-marquee-duration', mobile ? '24s' : '28s');
  };

  const cartMotion = () => {
    const drawer = document.querySelector('#cart-drawer');
    if (!drawer) return;
    const wake = () => {
      drawer.classList.remove('av-cart-awake');
      void drawer.offsetWidth;
      drawer.classList.add('av-cart-awake');
    };
    new MutationObserver(() => {
      const dialog = drawer.querySelector('.theme-drawer__dialog');
      const visible = !drawer.hasAttribute('hidden') || dialog?.getAttribute('open') !== null || drawer.matches(':not([hidden])');
      if (visible) wake();
    }).observe(drawer, { attributes: true, subtree: true, attributeFilter: ['open','hidden','aria-hidden'] });

    document.addEventListener('click', e => {
      const add = e.target.closest('.add-to-cart-button, [name="add"]');
      if (add) {
        add.classList.remove('av-cart-flash');
        void add.offsetWidth;
        add.classList.add('av-cart-flash');
        setTimeout(() => add.classList.remove('av-cart-flash'), 760);
      }
    });
  };

  const variantMotion = () => {
    document.addEventListener('change', e => {
      const input = e.target.closest('variant-picker input, variant-selects input');
      if (!input) return;
      const label = input.id ? document.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
      if (label) {
        label.classList.remove('av-cart-flash');
        void label.offsetWidth;
        label.classList.add('av-cart-flash');
        setTimeout(() => label.classList.remove('av-cart-flash'), 760);
      }
    });
  };

  const buttonArrows = () => {
    qsa('.av-btn--wide span, .av-catalog-card__cta span, .av-contact-form__submit span').forEach(el => {
      el.style.transition = 'transform 320ms cubic-bezier(.16,1,.3,1)';
      el.parentElement?.addEventListener('mouseenter', () => { if (!reduced) el.style.transform = 'translate(3px,-3px)'; });
      el.parentElement?.addEventListener('mouseleave', () => { el.style.transform = ''; });
    });
  };

  const boot = () => {
    prepare();
    observeReveals();
    parallax();
    storyProgress();
    marquee();
    cartMotion();
    variantMotion();
    buttonArrows();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
